const reviewerListData = [
  {
    id: '0',
    name: 'Tan',
    stars: 4,
    message:
      'J’aime beaucoup l’application Tanflix qui propose beaucoup de choix' +
      'en therme de séries/films/animés..',
    img: 'https://source.unsplash.com/random/100x100?face,1',
    date: '01/02/2024',
  },

  {
    id: '1',
    name: 'Corgi',
    stars: 5,
    message:
      'L’application Tanflix est une bonne application. ' +
      'On y retrouve des produits variés pour tous les goûts.',
    img: 'https://source.unsplash.com/random/100x100?face,2',
    date: '12/12/2023',
  },

  {
    id: '2',
    name: 'Nutella',
    stars: 3,
    message:
      "L'application est rodée, efficace et rapide . 4 étoiles pour la technique.",
    img: 'https://source.unsplash.com/random/100x100?face,3',
    date: '03/02/2024',
  },

  {
    id: '3',
    name: 'David',
    stars: 4,
    message:
      "Application au top, l'expérience est fluide, logique et super bien pensée.",
    img: 'https://source.unsplash.com/random/100x100?face,4',
    date: '03/02/2024',
  },

  {
    id: '4',
    name: 'Stephane',
    stars: 3,
    message:
      "J'ai un abonnement Tanflix pour 4 personnes et toute la fimille en profite." +
      ' Vaut vraiment le coup.',
    img: 'https://source.unsplash.com/random/100x100?face,5',
    date: '25/01/2024',
  },

  {
    id: '5',
    name: 'Rose',
    stars: 2,
    message:
      'Cette application est rapide.' +
      ' Je ne comprends pas pourquoi certaines séries ne sont pas complètes.',
    img: 'https://source.unsplash.com/random/100x100?face,6',
    date: '08/01/2024',
  },
]

export default reviewerListData
